/**
 * Shared Tailwind class strings for the operator app shells
 * (`AppShell`, `OrgAppShell`). Centralizes the scroll contract:
 *
 *   - Outer frame: locked to one dynamic viewport; document never scrolls.
 *   - Sidebar: fixed rail; only `<nav>` scrolls when links overflow.
 *   - Main: sole page scroll surface; scroll height matches content + footer.
 *
 * Use `h-full` (not `h-[100dvh]`) on the aside so the rail sizes against
 * the shell frame — a viewport-tall aside inside a shorter flex child (e.g.
 * when `DevSchemaParityBanner` is visible) was re-expanding the grid row
 * and reproducing the empty "scroll past the content" band on short pages
 * like `/calendar`.
 */

/** ToastProvider child — caps the entire authenticated shell. */
export const operatorShellFrameClass =
  'flex h-[100dvh] max-h-[100dvh] flex-col overflow-hidden';

/** Desktop grid + mobile flex column inside the frame. */
export const operatorShellGridClass =
  'flex min-h-0 h-full max-h-full flex-1 flex-col overflow-hidden bg-paper md:grid md:h-full md:max-h-full md:grid-cols-[16rem_minmax(0,1fr)] md:grid-rows-[minmax(0,1fr)]';

/** Desktop sidebar rail. */
export const operatorShellAsideClass =
  'hidden md:flex h-full max-h-full min-h-0 shrink-0 flex-col overflow-hidden overscroll-none border-r border-rule bg-paper-2/40';

/** Right column wrapper (mobile header + drawer siblings live in the grid too). */
export const operatorShellMainColumnClass =
  'flex min-h-0 h-full max-h-full flex-1 flex-col overflow-hidden';

/** Scroll surface for route content + in-scroll footer. */
export const operatorShellMainClass =
  'min-h-0 h-full max-h-full flex-1 overflow-y-auto overscroll-y-contain';

/** Sidebar nav list — scrolls independently when tabs overflow. */
export const operatorShellNavClass =
  'flex-1 min-h-0 overflow-y-auto overscroll-y-contain px-5 pb-4 flex flex-col';
